/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-spinner-button',
  templateUrl: './spinner-button.component.html',
  styleUrls: ['./spinner-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerButtonComponent {
  defaultColor: ThemePalette = 'accent';

  @Input() label = '';
  @Input() color: ThemePalette = this.defaultColor;
  @Input() isSpinning = false;
  @Input() isDisabled = false;

  @Output() clickFunction: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  emitClickFunction(): void {
    this.clickFunction.emit();
  }
}
